"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardFlexWrapperMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
/** @class PropertyCardFlexWrapperMixin */
/** @method */
var PropertyCardFlexWrapperMixin = function PropertyCardFlexWrapperMixin(props) {
  return (0, _styledToken.default)('PropertyCard.flexArea.padding', function (padding) {
    return (0, _styledComponents.css)(["padding:", ";"], padding ? padding + "px" : (0, _spaceMixin.spaceMixin)('xs')(props));
  })(props);
};
exports.PropertyCardFlexWrapperMixin = PropertyCardFlexWrapperMixin;